module.exports = __webpack_public_path__ + "img/9.7ab39f2a.jpg";